import { render, staticRenderFns } from "./AreYouSureOnRequestModal.vue?vue&type=template&id=b296fb72&scoped=true&"
import script from "./AreYouSureOnRequestModal.vue?vue&type=script&lang=js&"
export * from "./AreYouSureOnRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSureOnRequestModal.vue?vue&type=style&index=0&id=b296fb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b296fb72",
  null
  
)

export default component.exports